/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceFirmwareUpdateSetAsNewest
 */
export interface DeviceFirmwareUpdateSetAsNewest {
    /**
     * 
     * @type {string}
     * @memberof DeviceFirmwareUpdateSetAsNewest
     */
    blob_name: string;
}

/**
 * Check if a given object implements the DeviceFirmwareUpdateSetAsNewest interface.
 */
export function instanceOfDeviceFirmwareUpdateSetAsNewest(value: object): value is DeviceFirmwareUpdateSetAsNewest {
    if (!('blob_name' in value) || value['blob_name'] === undefined) return false;
    return true;
}

export function DeviceFirmwareUpdateSetAsNewestFromJSON(json: any): DeviceFirmwareUpdateSetAsNewest {
    return DeviceFirmwareUpdateSetAsNewestFromJSONTyped(json, false);
}

export function DeviceFirmwareUpdateSetAsNewestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceFirmwareUpdateSetAsNewest {
    if (json == null) {
        return json;
    }
    return {
        
        'blob_name': json['blob_name'],
    };
}

export function DeviceFirmwareUpdateSetAsNewestToJSON(json: any): DeviceFirmwareUpdateSetAsNewest {
    return DeviceFirmwareUpdateSetAsNewestToJSONTyped(json, false);
}

export function DeviceFirmwareUpdateSetAsNewestToJSONTyped(value?: DeviceFirmwareUpdateSetAsNewest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'blob_name': value['blob_name'],
    };
}

